/**
 * @module confirmSyncQB
 * @description Settings Confirm 后将面板配置同步回 QB / DVA（方向②：panel → QB）
 *
 * **实施范围（2026-06-02 决策）**：方向② **仅** `column_sort` — 重排 `columnDimensions` /
 * `columnMetrics` 并刷新 `columnSortToken`。其余配置（description、statistics、crosstab 等）
 * 只存在于 Context base → convert 上传，QB 变更走方向① `useQBLinkagePipeline`，Confirm 时不写回 QB。
 *
 * 外部（`useSettingsDraft`）在 `COMMIT_DRAFT` 之后调用 `confirmSyncToQB`；有 patch 时单次 DVA save。
 *
 * @see docs/图表设置面板-QB联动与字段列排序完整技术方案.md §6.6、§10.1 S13
 */

import { CHART_OLD_NAMESPACE } from '@/pages/datalab/models/namespaces';
import { buildColumnSortSyncPatch } from './columnSort';
import type { IConfirmSyncToQBParams } from './types';
export * from './columnSort';

/**
 * Confirm 后统一入口：合并方向② patch，单次写入 DVA QB state
 */
export function confirmSyncToQB(params: IConfirmSyncToQBParams): void {
  const payload = {
    ...buildColumnSortSyncPatch(params),
    // 其他配置项 patch 在此 spread 合并
  }

  // 没有需要合并的就不需要同步了.
  if (!(Object.keys(payload).length > 0)) {
    return;
  }
  params.dvaDispatch({
    type: `${CHART_OLD_NAMESPACE}/save`,
    payload,
  });
}
